import { useEffect, useRef } from "react";
import * as R from "ramda";

function useDeepEffect(callback, dependencies) {
  const prevDependenciesRef = useRef(null);

  if (!R.equals(prevDependenciesRef.current, dependencies)) {
    prevDependenciesRef.current = dependencies;
  }

  useEffect(callback, prevDependenciesRef.current);
}

export default useDeepEffect;
